import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { ClipboardButton, Icon } from "components/common";
import { FormGroup, InputGroup, FormControl } from "components/bootstrap";
import useShowRouteFromGRN from "routing/hooks/useShowRouteFromGRN";
const StyledFormControl = styled(FormControl)(
  ({ theme }) => css`
    &[readonly] {
      background-color: ${theme.colors.input.background};
    }
  `
);
const InputGroupAddon = styled(InputGroup.Addon)`
  padding: 0;
`;
const StyledClipboardButton = styled(ClipboardButton)`
  border-radius: 0;
  border: 0;
`;
const ShareableEntityURL = ({ entityGRN }) => {
  const { t } = useTranslation("users");
  const entityRoute = useShowRouteFromGRN(entityGRN);
  const entityUrl = `${window.location.origin.toString()}${entityRoute}`;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(StyledFormControl, { type: "text", value: entityUrl, readOnly: true }), /* @__PURE__ */ React.createElement(InputGroupAddon, null, /* @__PURE__ */ React.createElement(
    StyledClipboardButton,
    {
      text: entityUrl,
      buttonTitle: t("permissions.shareable_url.copy_title"),
      title: /* @__PURE__ */ React.createElement(Icon, { name: "content_copy" })
    }
  )))), /* @__PURE__ */ React.createElement("div", null, t("permissions.shareable_url.hint")));
};
export default ShareableEntityURL;
